import { render, staticRenderFns } from "./BasePriceComponent.vue?vue&type=template&id=2d195cec&scoped=true&"
import script from "./BasePriceComponent.vue?vue&type=script&lang=js&"
export * from "./BasePriceComponent.vue?vue&type=script&lang=js&"
import style0 from "./BasePriceComponent.vue?vue&type=style&index=0&id=2d195cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d195cec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
